<template>
  <div class="contentbox">
    <div class="logo">
        <img :src="logopic ? `/uploads/${logopic}` : '/static/img/logo.png'" height="92" alt="" @click="$router.push('/')">
    </div>
    <div class="inqBox">  
           <div class="rightBox">
            <div class="btngroup">
              <ul >
                <li class="active">
                  <a  @click="isSelect = 0" :class="isSelect == 0 || isSelect == 1 ? 'active button' : 'button'">
                    <span class="button__text">
                      {{ isSelect == 0 ? '证书查询' : isSelect == 1 ? '测评查询' : '课题查询' }}
                    </span>
                  </a>
                </li>
                <li >
                  <a :href="gourl" class="button">
                    <span class="button__text">
                      证书说明
                    </span>
                  </a>
                </li>
                <li>
                  <a href="/ExamLogin" class="button">
                    <span class="button__text">
                      测评中心
                    </span>
                  </a>
                </li>
                <li >
                  <a href="https://www.zhcpw.org.cn/kscx"  class="button">
                    <span class="button__text">
                      查询测评报告
                    </span>
                  </a>
                </li>
              </ul>
              <!-- <img src="/static/img/niukou.png" class="kouniu1" alt=""/>
              <img src="/static/img/niukou.png" class="kouniu2" alt=""/> -->
            </div>
              <div class="textBox">
                <!-- <h2>证书说明</h2>
              <p>持证人参加职业人才测评项目组组织的职业技能等级考试，考试合格。具备了该专业所要求的专业水平与职业技能。特发此证。</p> -->
                <h2 style="margin-top:62px">温馨提示</h2>
                <p v-show="seltype == 'gr'">
                  1、点击证书类别，选择持有证书同类别项目名称点击确认；<br/>
                  2、输入：人名+身份证号+证书编号点击查询；<br/>
                  3、输入：人名+证书编号点击查询；<br/>
                  4、输入：身份证号+证书编号点击查询；<br/>
                  5、证书编码中若有英文字母全部需用大写字母填写；<br/>
                  6、身份证号中若有英文字母全部需用大写字母填写。<br/>
                </p>
                <p v-show="seltype == 'qy'">
                  1、点击证书类别，选择持有证书同类别项目名称点击确认；<br/>
                  2、输入：企业名称+统一社会信用代码+签发编号点击查询；<br/>
                  3、输入：企业名称+签发编号点击查询；<br/>
                  4、输入：统一社会信用代码+签发编号点击查询；<br/>
                  5、签发编号中若有英文字母全部需用大写字母填写；<br/>
                  6、统一社会信用代码中若有英文字母全部需用大写字母填写。<br/>
                </p>
              </div>
            </div>
          <div class="leftBox" v-show="isSelect==0">
            <h1><span v-if="isSelect == 0">培训信息查询系统</span><span v-else-if="isSelect == 1">测评信息查询</span><span v-else-if="isSelect == 2">课题信息查询</span></h1>

            <el-select class="intype" v-model="cert.certtypename" placeholder="请选择类别" @change="certtypechage">
              <el-option
                v-for="(certType,index) in arrCertTypes"
                :key="index"
                :label="certType.name"
                :value="certType.name">
              </el-option>
            </el-select>
            <div style="position: relative;overflow: hidden;height:276px;" v-show="seltype=='gr'">
              <div class="textbox"><input type="text" v-model="cert.name" class="inname" placeholder="请输入姓名"/></div>
              <div class="textbox"><input type="text" v-model="cert.cardid" class="inid" placeholder="请输入证件号码"/></div>
              <div class="textbox"><input type="text" v-model="cert.code" class="incert" placeholder="请输入证书编号"/></div>             
            </div>
            <div v-show="seltype=='qy'">
              <div class="textbox"><input type="text" v-model="cert.qiyename" class="inname" placeholder="企业名称"/></div>
              <div class="textbox"><input type="text" v-model="cert.socialcreditcode" class="inid" placeholder="统一社会信用代码"/></div>
              <div class="textbox"><input type="text" v-model="cert.code" class="incert" placeholder="签发编号"/></div>
            </div>
            <button @click="submitForm() ">查询</button>
          </div>
          <div class="leftBox" v-show = "isSelect==1">
            <h1><span v-if="isSelect == 0">培训信息查询</span><span v-else-if="isSelect == 1">测评信息查询系统</span><span v-else-if="isSelect == 2">课题信息查询</span></h1>

            <el-select class="intype" v-model="cert.certtypename" placeholder="类别" @change="certtypechage">
              <el-option
                v-for="(certType,index) in arrRongyTypes"
                :key="index"
                :label="certType.name"
                :value="certType.name">
              </el-option>
            </el-select>
            <div v-show="seltype=='gr'">
              <div class="textbox"><input type="text" v-model="cert.name" class="inname" placeholder="请输入姓名"/></div>
              <div class="textbox"><input type="text" v-model="cert.code" class="incert" placeholder="请输入证书编号"/></div>
              
              
            </div>
            <div v-show="seltype=='qy'">
              <div class="textbox"><input type="text" v-model="cert.qiyename" class="inname" placeholder="企业名称"/></div>
              <div class="textbox"><input type="text" v-model="cert.socialcreditcode" class="inid" placeholder="统一社会信用代码"/></div>
              <div class="textbox"><input type="text" v-model="cert.code" class="incert" placeholder="签发编号"/></div>
            </div>
            <button @click="submitForm() ">查询</button>
          </div>
          <div class="leftBox" v-show = "isSelect==2">
            <h1><span v-if="isSelect == 0">培训信息查询</span><span v-else-if="isSelect == 1">测评信息查询</span><span v-else-if="isSelect == 2">课题信息查询</span></h1>

            <el-select class="intype" v-model="cert.certtypename" placeholder="类别">
              <el-option
                v-for="(certType,index) in arrKetiTypes"
                :key="index"
                :label="certType.name"
                :value="certType.name">
              </el-option>
            </el-select>
            <div>
              <input type="text" v-model="cert.name" class="inname" placeholder="课题名称"/>
              <input type="text" v-model="cert.code" class="incert" placeholder="课题编码"/>
            </div>
            <button @click="submitForm() ">查询</button>
          </div>
         
        
        
        
    </div>
    <div class="recodenum">备案号：{{ recodenum }}</div>
    <el-dialog title="请选择测评名称" width="50%" :visible.sync="qyoccupationFlag">
        <el-form >
          <el-form-item label="测评名称">
            <el-select v-model="selcertname" placeholder="请选择测评名称">
              <el-option v-for="(cet,index) in occupations" :key="index" :label="cet.certname" :value="cet.certname">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="occupationFlag = false">取 消</el-button>
          <el-button type="primary" @click="qyhandleInq()">确 定</el-button>
        </div>
      </el-dialog>
    <el-dialog title="请选择职业名称" width="50%" :visible.sync="occupationFlag">
        <el-form >
          <el-form-item label="职业名称">
            <el-select v-model="selcertname" placeholder="请选择职业名称">
              <el-option v-for="(cet,index) in occupations" :key="index" :label="cet.certname" :value="cet.certname">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="occupationFlag = false">取 消</el-button>
          <el-button type="primary" @click="handleInq()">确 定</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>

import { certificateGR ,certificateQY,getPersonalMember} from '@/request/index';
import { getCertTypes,getFindPage } from '@/request/get';
const rate = window.outerWidth / 1920;
export default {
  metaInfo: {
    title: '北京软数人才测评网',
    meta: [
      {
        name: 'viewport', content:
          `width=1920, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`
      }
    ]
  },
  name: "inquery",
  components: {
  },
  data() {
    return {
      occupations: [],
      occupationFlag:false,
      qyoccupationFlag:false,
      seltype:"gr",
      cert: {
        name: "",
        code:"",
        cardid:"",
        certtypename:""
      },
      selcertname:"",
      gourl:"",
      arrCertTypes:[],
      arrRongyTypes:[],
      arrKetiTypes:[],
      isSelect:0
    }
  },
  created(){
   this.getCertTypes();
   this.getFindPage();
   if(this.$route.query.inqtype=='ry')
   {
    this.isSelect=1;
   }else if(this.$route.query.inqtype=='kt')
   {
    this.isSelect=2;
   }else{
    this.isSelect=0;
   }

  },
  computed:{
    logopic() {
      return this.$store.getters.logopic;
    },
    recodenum() {
      return this.$store.getters.recodenum;
    },
  },
  watch:{
    isSelect(){
      this.cert.certtypename = "";
    }
  },
  mounted() {
    var lastTouchEnd = 0;
    document.addEventListener(
      "touchend",
      function (event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
  },
  methods: {
    certtypechage(newval) {
      if(newval=="企业测评"){
        this.seltype='qy'
      }else{
        this.seltype='gr'
      }
    },
    async getFindPage() {
      let result = await getFindPage();
      result = result.data || [];
      this.$store.dispatch("SET_PLATES", result)
      let { plates } = this.$store.state;
    let list = plates.filter((item) => '证书说明' == item.name);
    let uuid = list[0].uuid;
    this.gourl = `/news/info/${uuid}/000000`
    },
    goHome() {
      this.$router.push("/");
    },
    handleInq() {
      if (!this.selcertname) {
        this.$message.error("请选择职业名称");
        return;
      }
      for(let i=0;i<this.occupations.length;i++)
      { 
        if(this.occupations[i].certname==this.selcertname)
        {
          this.cert = this.occupations[i];
          break;
        }
      }
      this.$router.push({
        name: "Show",
        query: {
          name: this.cert.name,
          code: this.cert.code,
          certtypename: this.cert.certtypename
        }
      })
    },
    qyhandleInq() {
      if (!this.selcertname) {
        this.$message.error("请选择测评名称");
        return;
      }
      for(let i=0;i<this.occupations.length;i++)
      { 
        if(this.occupations[i].certname==this.selcertname)
        {
          this.cert = this.occupations[i];
          break;
        }
      }
      this.$router.push({
        name: "Show",
        query: {
          name: this.cert.qiyename,
          code: this.cert.code,
          certtypename: this.cert.certtypename,
          type:'qy'
        }
      })
    },
    async getCertTypes(){
      let result = await getCertTypes();
      for(let i=0;i<result.data.length;i++) {
        if(result.data[i].type=='测评')
        {
          this.arrRongyTypes.push(result.data[i])
        }else if(result.data[i].type=='课题')
        {
          this.arrKetiTypes.push(result.data[i])
        }else{
          this.arrCertTypes.push(result.data[i])
        }
      }
    },
    /**
     *  cname: "单位名称"或姓名,
        ccode: "信用代码"或证件号,
        bzcode: "证书编号"或标准号
    */
    async submitForm() {
      if(!this.cert.certtypename)
      {
        this.$message.error("请选择证书类别");
        return;
      }
      if(this.seltype=='qy')
      {
        if ((this.qiyename == "" && this.code == "")
          || (this.qiyename == "" && this.socialcreditcode == "")
          || (this.code == "" && this.socialcreditcode == "")) {
          return;
        }
        let result =await certificateQY(this.cert.certtypename,this.cert.code,this.cert.qiyename,this.cert.socialcreditcode);
        if(result.data.length==1)
        {
          this.cert = result.data[0];
          this.$router.push({
            name: "Show",
            query: {
              name: this.cert.qiyename,
              code: this.cert.code,
              certtypename: this.cert.certtypename,
              type:'qy'
            }
          })
        }else if(result.data.length>1)
        {
          this.occupations = result.data || [];
          this.occupationFlag = true;
        }
      }else{
        if ((this.name == "" && this.code == "")
          || (this.name == "" && this.cardid == "")
          || (this.code == "" && this.cardid == "")) {
          return;
        }
        // if(this.cert.certtypename.indexOf("测评")>-1)
        // {
        //   if ((this.cert.name == "" && this.cert.code == "")) {
        //     return;
        //   }
        //   let result =await getPersonalMember(this.cert.name,this.cert.code);
        //   if(result.data.length>0)
        //   {
        //     this.$router.push({
        //       name: "MemberRlt",
        //       query: {
        //         name: this.cert.name,
        //         code: this.cert.code,
        //         inqType:"gr"
        //       }
        //     })
        //   }else{
        //     this.$message.error("您输入的信息不存在，谨防假冒。");
        //   }
        //   return
        // }
        let result =await certificateGR(this.cert.certtypename,this.cert.code,this.cert.name,this.cert.cardid);
        if(result.data.length==1)
        {
          this.cert = result.data[0];
          this.$router.push({
            name: "Show",
            query: {
              name: this.cert.name,
              code: this.cert.code,
              certtypename: this.cert.certtypename,
              inqType:this.isSelect
            }
          })
        }else if(result.data.length>1)
        {
          this.occupations = result.data || [];
          this.occupationFlag = true;
        }
      }
      
    }
  }
};
</script>
<style scoped >

.logo{
  width: 1300px;
    text-align: left;
    position: relative;
    margin:46px auto 56px;
}
.logo img{
  margin-left:36px;
}
.contentbox{
  position: relative;
    width: 100%;
    margin: 0 auto;
height: 1080px;
    background-image:url(/static/img/img/bg_rogyu.png);
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: left bottom;
    overflow: hidden;
}
.inqBox{
    position: relative;
    box-sizing: border-box;
    width: 1069px;
    height: 648px;
    opacity: 1;
    margin: auto;
    text-align: left;
    background: #FFFFFF;
box-shadow: 0px 12px 51px 0px rgba(68,98,207,0.19);
opacity: 0.9;
border-radius: 20px;
}
.leftBox h1{
  position: relative;
  margin-top: 50px;
height: 35px;
font-size: 35px;
font-family: PingFang SC;
font-weight: bold;
color: #252626;
line-height: 35px;
text-align: center;
}
.leftBox h1::after{
  position: absolute;
  content:'';
  left:315px;
  bottom:-29px;
 width: 37px;
height: 8px;
background: #2F8EEC;
border-radius: 3px;
}
.leftBox input {
padding-left: 90px;
   
    
    background-position: 9px 13px;
    
    font-size: 21px;
    width: 374px;
height: 67px;
background: #F2F4F9;
background-repeat: no-repeat;
border-radius: 5px;
background-position: 23px center;
}
.leftBox .intype{
      margin-top:40px ;
    padding-left: 90px;
    background-position: 9px 13px;
    
    font-size: 21px;
    width: 374px;
height: 67px;
background: #F2F4F9;
background-repeat: no-repeat;
border-radius: 5px;
background-position: 23px center;
}
.textbox{
  margin: 0 auto;
  position: relative;
    margin-top:25px ;
   width: 464px;
height: 67px;
background: #F2F4F9;

}
.intype::before,.textbox::before{
    content:'';
    position: absolute;
    top:21px;
    left: 72px;
    width: 1px;
height: 25px;
background: #E3E6EF;
z-index: 1;
   }
.leftBox .inid{
    background-image: url(/static/img/img/bianhaoda.png);
}
.leftBox .incert{
    background-image: url(/static/img/img/da.png);
}
.leftBox .inname{
  background-image: url(/static/img/img/shoujiios.png);
}
.leftBox .intype{
  background-image: url(/static/img/img/da.png);
}
.leftBox button {
  margin-top: 50px;
  width: 464px;
height: 67px;
background: #2F8EEC;
border-radius: 5px;
font-size: 29px;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 67px;
text-align: center;
opacity: 1;
}
.inqBox{
  height: 648px;
  display: flex;
}
.leftBox{
  position: relative;

  width:669px;
  /* height: */
  height: 648px;
 text-align: center;
  display: inline-block;
  background: #FFFFFF;
  opacity: 1;
  z-index: 2;
}
.rightBox{
 width: 400px;
height: 648px;
background: linear-gradient(141deg, #E0F0FF, #FDFEFF);
opacity: 0.8;
border-radius: 20px 0px 0px 20px;
display: inline-block;
}
.textBox{
  height: 369px;
  width: 376px;
    text-align: left;
    margin-left: 24px;
}
.textBox h2{
  height: 25px;
  font-size: 18px;
padding-left: 37px;
font-family: PingFang SC;
line-height: 25px;
font-weight: bold;
color: #FF411C;
 background-image:url(/static/img/img/tishi.png);
    background-size: 25px;
    background-repeat: no-repeat;
    background-position: left center;
}
.textBox p{

font-family: PingFang SC;
  margin-top:24px;
  font-size: 14px;
/* font-family: Inter-Regular, Inter; */
font-weight: 400;
color: #585B63;
line-height: 32px;
}
.intype >>>.el-input__inner{
  background-color:transparent;
  border:none;
  height: 67px;
    line-height: 67px;
    padding:0px;
    font-size: 21px;
    color: #000000;
}
.btngroup{
  position: relative;
    color: #585B63;
    font-size: 20px;
    width: 400px;
    height:296px;
    padding-top: 15px;
}
.btngroup ul li {
  position: relative;
  width: 314px;
  height: 70px;
  padding-left: 32px;
  padding-right:54px;
  text-align: left;
  line-height: 70px;
  font-size: 20px;
}
.btngroup ul li::after{
  content:'';
  position: absolute;
  left:24px;
  bottom:0;
  width: 358px;
height: 1px;
border: 1px solid #FFFFFF;
opacity: 0.8;
}
.btngroup ul li a{
  color:#585B63;
}
.btngroup ul li.active{
  background-image:url(/static/img/img/youbiansnaji.png);
  background-repeat: no-repeat;
  background-size: 11px 13px;
  background-position:335px center;
}
.btngroup ul li{
  background-image:url(/static/img/img/bianlji.png);
  background-repeat: no-repeat;
  background-size: 8px 16px;
  background-position:337px center;
}
.btngroup ul li a.active{
  font-size: 20px;
  color: #2F8EEC;
  font-weight: bold; 
}
.kouniu1{
  position: relative;
    top: -180px;
    left: 110px;
    width: 52px;
}
.kouniu2{
  position: relative;
    top: -67px;
    left: 57px;
    width: 52px;
}
.inqBox .backhome{
  font-size: 14px;
    float: right;
    color: #fff;
    border-bottom: solid 1px;
}
.inqBox .header ul{
  display: flex;
  /* width: 500px;
  padding-left: 55px; */
  width: 1200px;
}
.inqBox .header ul li{
  
  display: inline-block;
  width: 600px;
  
}
.inqBox .header ul li a{
  font-size: 20px;
  /* border-bottom: solid 1px; */
  color: #fff;
}
.active span{
  /* color: #ffcc1a;
  border-bottom:#ffcc1a; */
}
.btntwo{
  margin-top:40px;
}
.btntwo .kouniu2{
 top: -88px
}
.btntwo .kouniu1{
  top:38px;
}
  .recodenum{
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 34px;
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #AEB8C3;
    line-height: 14px;
    text-align: center;
  }
</style>
